import { FC, useCallback } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';

import PaymentType from 'components/PaymentType';
import PaymentStatus from 'components/PaymentStatus';
import ConfirmableIconButton from 'components/ConfirmableIconButton';

import { PaymentRow_payment$key } from '__generated__/PaymentRow_payment.graphql';

type Props = {
  payment: PaymentRow_payment$key;
  onDelete: (id: string) => void;
};

const PaymentRow: FC<Props> = props => {
  const { onDelete } = props;

  const payment = useFragment(
    graphql`
      fragment PaymentRow_payment on Payment {
        id
        paymentDate
        details
        amount
        createdAt
        user {
          name
        }

        ...PaymentType_payment
        ...PaymentStatus_payment
      }
    `,
    props.payment
  );

  const { id, paymentDate, details, amount, createdAt, user } = payment;

  const handleDelete = useCallback(() => {
    onDelete(id);
  }, [id, onDelete]);

  const canDelete = user?.name && id !== 'tempPayment';

  return (
    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell>{paymentDate as string}</TableCell>

      <TableCell align="center">
        <PaymentType payment={payment} />
      </TableCell>

      <TableCell align="center">{details}</TableCell>

      <TableCell align="center">
        <PaymentStatus payment={payment} />
      </TableCell>

      <TableCell align="center">€{amount}</TableCell>

      <TableCell align="center">
        <Tooltip title={createdAt as string}>
          <Box>{user?.name ?? 'Sistema'}</Box>
        </Tooltip>
      </TableCell>

      <TableCell align="center">
        {canDelete && (
          <Tooltip title="Trinti">
            <ConfirmableIconButton onConfirm={handleDelete}>
              <DeleteIcon fontSize="small" />
            </ConfirmableIconButton>
          </Tooltip>
        )}
      </TableCell>
    </TableRow>
  );
};

export default PaymentRow;
